import { createContext } from 'react';

import { SingleSelectContextType } from '../../utils/types/stateful-list.types';

export const SingleSelectContext = createContext<SingleSelectContextType | null>(null);
